/* eslint-disable @next/next/no-img-element */
import React from "react";

function PageAuthLayoutFooter({ tenant, event, wrapperClassname }) {
  return (
    <div>
      <div id="footer" className={`footer ml-0 mt-5 ${wrapperClassname}`}>
        <div className="row ml-0 mr-0 p-0">
          <div className="col-md-10">
            <address className="mb-0">
              {event && <strong className="mr-1">{event?.long_name}</strong>}
              {tenant?.abn && (
                <span className="mr-2">
                  <abbr title="Australian Business Number">ABN: </abbr>{" "}
                  {tenant?.abn}
                </span>
              )}
              {tenant?.company_address && (
                <span>{tenant?.company_country}</span>
              )}
            </address>
            <div className="d-flex flex-wrap">
              <div>
                {tenant?.phone && (
                  <span className="mr-2">
                    <span>Phone Number: </span>{" "}
                    {tenant?.phone.includes("+")
                      ? tenant?.phone
                      : `+${tenant?.phone}`}
                    ,
                  </span>
                )}
              </div>
              <div>
                {tenant?.membership_email && (
                  <span>
                    Email:{" "}
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={`mailto:support@currinda.com`}>
                      {`support@currinda.com`}
                    </a>
                  </span>
                )}
              </div>
            </div>

            <a
              rel="noreferrer"
              target="_blank"
              href={"https://www.currinda.com/privacy-policy"}>
              Currinda Privacy Policy
            </a>
            <br />
            <a
              className={` ml-0`}
              rel="noreferrer"
              target="_blank"
              href="http://currinda.com">
              Event Management Software by Currinda
            </a>
          </div>
          <div className="col-md-2 text-right">
            {tenant?.header_logo && (
              <img
                src={tenant?.header_logo}
                alt={tenant?.long_name}
                width={100}
                layout="fill"
                objectFit="contain"
              />
            )}
          </div>
          <div className="col-md-12 justify-content-center align-items-center mt-2">
            Please report bugs and feedback to{" "}
            <a
              rel="noreferrer"
              target="_blank"
              href={`mailto:support@currinda.com`}>
              {`support@currinda.com`}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageAuthLayoutFooter;
